import configureSentry from './configureSentry'
import { DEFAULT_LOCALE } from '~/lib/getSupportedLocale'

export const mockBackendBaseUrl = 'https://live-bidding-api.localhost/backend'

// Module-level reference to the current configuration instance
let currentConfiguration = null

export function getCurrentConfiguration() {
  return currentConfiguration
}

async function fetchConfig(path) {
  const res = await fetch(path)

  return res.json()
}

function shouldEnableMockApi() {
  return document.location.search.includes('mockApi')
}

class Configuration {
  static async load(path) {
    const config = await fetchConfig(path)

    return new Configuration(config)
  }

  constructor(options) {
    this.hosts = options.hosts || []

    const hostConfig = this.findHostConfig(window.location.hostname)

    if (!hostConfig) {
      throw new Error(
        `No host configuration found for ${window.location.hostname}`
      )
    }

    this.auctionetBaseUrl = hostConfig.auctionetBaseUrl
    this.backendBaseUrl = hostConfig.backendBaseUrl
    this.messageBusPollingInterval = options.messageBusPollingInterval
    this.initialLocale = options.initialLocale || DEFAULT_LOCALE

    this.sentry = configureSentry({ backendBaseUrl: this.backendBaseUrl })

    const searchParams = new URLSearchParams(document.location.search)

    this.inAppShell = searchParams.get('inAppShell') === 'true'

    this.envBar = options.envBar || {
      label: 'N/A',
      background: '#f0f',
      visible: 'localStorage',
    }

    if (shouldEnableMockApi()) {
      this.enableMockApi = true
      this.backendBaseUrl = mockBackendBaseUrl
    } else {
      this.enableMockApi = false
    }

    // Store reference for non-React code that needs configuration
    currentConfiguration = this
  }

  findHostConfig(hostname) {
    return this.hosts.find((config) => config.frontendHost === hostname)
  }
}

export default Configuration
